<template>
  <header class="c-header header">
    <AppHeaderLogo class="header__title" />
    <h2 class="header__subtitle">
      {{ $translate('FIFTEEN_PUZZLE') }}
    </h2>
  </header>
</template>

<script>
import AppHeaderLogo from '@/components/AppHeaderLogo.vue';

export default {
  name: 'AppHeader',

  components: {
    AppHeaderLogo,
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 10px;
  left: 0;
  width: 100%;

  text-align: center;

  @include mq($and: $is-iphonex) {
    top: 15px;
  }

  @include mq($and: $is-iphone11) {
    top: 15px;
  }

  @include mq($and: $is-iphoneMax) {
    top: 15px;
  }

  @include mq(ipadL) {
    top: 0;
  }

  &__title {
    display: inline-block;
    position: relative;
    width: calc(100% - 80px);
    margin-bottom: 0;

    @include mq(ipadL) {
      width: calc(100% - #{$unit-vw * 8});
      margin-bottom: 0;
      transform: translateY(-25%);
    }
  }

  &__subtitle {
    margin-top: 10px;

    letter-spacing: 2px;
    font-size: 20px;
    text-transform: uppercase;
    font-family: $font-family-h;

    @include mq(ipadL) {
      font-size: 25px;
      margin-top: -15px;
    }

    @include mq(d) {
      font-size: 30px;
    }

    @include mq(dm) {
      font-size: 36px;
    }
  }

  @at-root .in-app:not(.in-fullpage) & {
    top: 65px;

    .header__title {
      display: none;
    }

    .header__subtitle {
      margin-top: 0;
      font-size: 32px;
      letter-spacing: 3px;
    }
  }

  @at-root .in-fullpage & {
    top: 50px;

    @include mq($and: $is-iphonex) {
      top: 70px;
    }
    @include mq($and: $is-iphone11) {
      top: 70px;
    }
    @include mq($and: $is-iphoneMax) {
      top: 70px;
    }
  }
}
</style>
